import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "FuelCardListPage" */
	'pages/vehicle/FuelCard/FuelCardListPage'));

export default [{ component, exact: true, path: '/fuel_cards' }];